(function () {
  var root = document.querySelector('[data-contact-page]');
  if (!root) return;

  var params = new URLSearchParams(window.location.search);
  if (params.get('topic') === 'calendar') {
    var note = root.querySelector('[data-contact-calendar-note]');
    if (note) note.hidden = false;
  }

  var message = params.get('message');
  var field = root.querySelector('[data-contact-message]');
  if (message && field && !field.value) {
    field.value = message;
  }
})();
